import { cioTrackEvent } from 'src/modules/cio';
import {
  AccountBonusIcon,
  AccountDepositIcon,
  AccountLoyaltyIcon,
  AccountTournamentsIcon,
  AccountWithdrawalIcon,
  BalanceIcon,
  UserIcon
} from 'src/svg/AccountMenuIcons';
import { SVGPropsIcon } from 'src/types';

export type ProfileMenuItem = {
  route: string;
  content: string;
  Icon: (props: SVGPropsIcon) => JSX.Element;
  onClick?: () => void;
};

export const profileMenuItems: ProfileMenuItem[] = [
  {
    route: '/account/profile',
    content: 'profileMenuItems.profile',
    Icon: UserIcon
  },
  {
    route: '/account/userBalance',
    content: 'profileMenuItems.balance',
    Icon: BalanceIcon
  },
  {
    route: '/account/deposit',
    content: 'profileMenuItems.deposit',
    Icon: AccountDepositIcon,
    onClick: () => cioTrackEvent('deposit_btn_click', 'account')
  },
  {
    route: '/account/withdrawal',
    content: 'profileMenuItems.fundsWithdrawal',
    Icon: AccountWithdrawalIcon
  },
  {
    route: '/account/bonus',
    content: 'profileMenuItems.promo',
    Icon: AccountBonusIcon
  },
  {
    route: '/account/vip',
    content: 'profileMenuItems.vip',
    Icon: AccountLoyaltyIcon
  },
  {
    route: '/account/tournaments',
    content: 'profileMenuItems.tournaments',
    Icon: AccountTournamentsIcon
  }
];
